import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { MapPin, Phone, Mail, Scale } from 'lucide-react';

export default function Footer() {
  const { t, language } = useLanguage();

  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Scale className="h-6 w-6 text-[#C5A059]" />
              <span className="text-xl font-semibold tracking-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                <span className="text-[#C5A059]">ÖZTÜRK</span>
                <span className="text-[#F3F4F6] font-light ml-1">HUKUK</span>
              </span>
            </div>
            <p className="text-[#A1A1AA] text-sm leading-relaxed">{t('footer.description')}</p>
          </div>
          <div>
            <h4 className="text-[#F3F4F6] font-semibold mb-4 text-sm uppercase tracking-[0.2em]">{t('footer.quick_links')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-[#A1A1AA] hover:text-[#C5A059] text-sm transition-colors">{t('nav.about')}</Link>
              <Link to="/services" className="text-[#A1A1AA] hover:text-[#C5A059] text-sm transition-colors">{t('nav.services')}</Link>
              <Link to="/articles" className="text-[#A1A1AA] hover:text-[#C5A059] text-sm transition-colors">{t('nav.articles')}</Link>
              <Link to="/contact" className="text-[#A1A1AA] hover:text-[#C5A059] text-sm transition-colors">{t('nav.contact')}</Link>
            </div>
          </div>
          <div>
            <h4 className="text-[#F3F4F6] font-semibold mb-4 text-sm uppercase tracking-[0.2em]">{t('footer.services')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/services" className="text-[#A1A1AA] hover:text-[#C5A059] text-sm transition-colors">{t('nav.services')}</Link>
              <Link to="/contact" className="text-[#A1A1AA] hover:text-[#C5A059] text-sm transition-colors">{t('nav.contact')}</Link>
            </div>
          </div>
          <div>
            <h4 className="text-[#F3F4F6] font-semibold mb-4 text-sm uppercase tracking-[0.2em]">{t('footer.contact_info')}</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-[#C5A059] mt-0.5 flex-shrink-0" /><span className="text-[#A1A1AA] text-sm">{t('contact.address')}</span></div>
              <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#C5A059] flex-shrink-0" /><span className="text-[#A1A1AA] text-sm">{t('contact.phone_number')}</span></div>
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#C5A059] flex-shrink-0" /><span className="text-[#A1A1AA] text-sm">{t('contact.email_address')}</span></div>
            </div>
          </div>
        </div>
        <div className="section-divider mb-6" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#52525B] text-xs">&copy; {new Date().getFullYear()} Öztürk Hukuk. {t('footer.rights')}</p>
          <div className="flex gap-4">
            <span className="text-[#52525B] hover:text-[#A1A1AA] text-xs cursor-pointer transition-colors">{t('footer.privacy')}</span>
            <span className="text-[#52525B] hover:text-[#A1A1AA] text-xs cursor-pointer transition-colors">{t('footer.terms')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
